/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { UIElementPropertyAccessor } from "./UIElementPropertyAccessor";
import { markType } from "./type";
import { Brush } from "./Brush";
/**
 * @hidden
 */
var CssColorPropertyAccessor = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CssColorPropertyAccessor, _super);
    function CssColorPropertyAccessor(a) {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.d = a;
        return _this;
    }
    CssColorPropertyAccessor.prototype.b = function (a) {
        var b = a;
        var c = b.getStyleProperty(this.d);
        return Brush.create(c);
    };
    CssColorPropertyAccessor.prototype.c = function (a, b) {
        var c = a;
        var d = b;
        var e = d._fill;
        c.setStyleProperty(this.d, e);
    };
    CssColorPropertyAccessor.$t = markType(CssColorPropertyAccessor, 'CssColorPropertyAccessor', UIElementPropertyAccessor.$);
    return CssColorPropertyAccessor;
}(UIElementPropertyAccessor));
export { CssColorPropertyAccessor };
//# sourceMappingURL=CssColorPropertyAccessor.js.map
